import React from "react";
import stylesASAP from "./stylesASAP";
import stylesMed from "../MedRep/stylesMed";
import { set, get } from "idb-keyval";
import { db } from "../firebase";

export default class DeliveryForm extends React.Component {
  constructor() {
    super();
    this.state = {
      authenticate: false,
      token: "",
      type: [],
      clientName: "",
      clientDetail: [],
      loading: true,
      alertUndefined: false,
      picking: [],
      SOL: [],
      totalOrderPriceTaxed: 0,
      settingArray: [],
      VAT: 0,
      VAT: 0,
      amount: [],
      transactionTypes: [
        { id: 0, name: "Sale Order" },
        { id: 1, name: "Return" },
        { id: 2, name: "Purchase" },
        { id: 3, name: "Invoices" },
        { id: 4, name: "Delivery" },
        { id: 5, name: "CSH" },
      ],
      settingArray: [],
    };
  }

  async componentDidMount() {
    const token = JSON.parse(localStorage.getItem("Token"));
    const type = JSON.parse(localStorage.getItem("TransactionType"));
    const client = JSON.parse(localStorage.getItem("ClientIdGlobal"));
    const clientName = JSON.parse(localStorage.getItem("SelectedClientName"));
    const picking = JSON.parse(localStorage.getItem("DeliveryPicking"));
    const items = JSON.parse(localStorage.getItem("Items"));
    const SOL = JSON.parse(localStorage.getItem("SOL"));
    const total = JSON.parse(localStorage.getItem("Total"));
    const selectedclient = JSON.parse(localStorage.getItem("SelectedClient"));
    const vat = JSON.parse(localStorage.getItem("VAT"));
    const signatureDate = JSON.parse(localStorage.getItem("SignatureDate"));
    const sigantureTime = JSON.parse(localStorage.getItem("SignatureTime"));
    const siganture = JSON.parse(localStorage.getItem("Signature"));
    const TotalWeight = JSON.parse(localStorage.getItem("TotalWeight"));
    const settingArray = JSON.parse(localStorage.getItem("SettingArray"));
    const amount = JSON.parse(localStorage.getItem("amount"));

    await this.setState({
      amount: amount,
      clientName: clientName,
      TotalWeight: TotalWeight,
      token: token,
      picking: picking,
      type: type,
      SOL: SOL,
      totalOrderPriceTaxed: total,
      selectedclient: selectedclient,
      VAT: vat,
      signatureDate: signatureDate,
      sigantureTime: sigantureTime,
      siganture: siganture,
      settingArray: settingArray,
    });

    if (client === 2002) {
      this.setState({ GlobalclientName: "Chehab" });
    }
    // db.disableNetwork()
    //     .then(() => {
    //         this.readData();
    //     });
    await this.readData();
    const final = "data:image/png;base64," + this.state.siganture;
    this.setState({ final: final });
  }

  readData = async () => {
    try {
      // Use 'get' method from idb-keyval to read data from IndexedDB
      const data = await get("Clients");

      if (data) {
        this.setState({ clients: data, loading: false });
        console.log("Clients from IndexedDB:", data);
        const clientIdToQuery = this.state.selectedclient; // Replace with the actual clientId you want to query
        const queriedClient = data.find(
          (client) => client.id === clientIdToQuery
        );
        this.setState({ clientDetail: queriedClient });
      } else {
        console.log("Clients not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading Clients from IndexedDB:", error);
    }
  };

  numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  render() {
    console.log(this.state.amount);

    return (
      <div>
        {this.state.clientDetail.id !== undefined ? (
          <div>
            {this.state.settingArray.map((item) => {
              if (item.key === "LogoURL") {
                return (
                  <img src={item.value} alt="Logo" style={{ float: 'right', width: '100px', height: 'auto' }} />
                );
              }
              return null; // To avoid warning about missing return
            })}

            <h1 className="text-center" style={stylesASAP.printtitle}>
              {this.state.transactionTypes[this.state.type].name}
            </h1>
            <div className="m-4">
              <div className="row">
                <p className="col" style={stylesASAP.printfont}>
                  Customer name: <b>{this.state.clientName}</b>
                </p>
                <p className="col" style={stylesASAP.printfont}>
                  Currency type: <b>{this.state.clientDetail.currency_id[1]}</b>
                </p>
              </div>

              <div className="row">
                <p className="col" style={stylesASAP.printfont}>
                  Customer Address:{" "}
                  <b>
                    {this.state.clientDetail.street +
                      ", " +
                      this.state.clientDetail.city +
                      ", " +
                      this.state.clientDetail.country_id[1] +
                      ", " +
                      this.state.clientDetail.state_id[1]}
                  </b>
                </p>
                <p className="col" style={stylesASAP.printfont}>
                  Transfer Date:{" "}
                  <b>
                    {new Date().toISOString().substring(0, 10) +
                      "   " +
                      ("0" + new Date().getHours()).slice(-2) +
                      new Date().toISOString().substring(13, 19)}
                  </b>
                </p>
              </div>

              <div className="row">
                <p className="col" style={stylesASAP.printfont}>
                  Customer Phone: <b>{this.state.clientDetail.mobile}</b>
                </p>
                <p className="col" style={stylesASAP.printfont}>
                  Customer Email: <b>{this.state.clientDetail.email}</b>
                </p>
              </div>
            </div>
            <div className="row " style={stylesASAP.hr}>
              <div className=" col-4" style={stylesASAP.title}>
                Name
              </div>
              <div className=" col-1" style={stylesASAP.title}>
                Qty
              </div>
              <div className=" col-2 text-center" style={stylesASAP.title}>
                Unit
              </div>
              {this.state.settingArray.map((item) => {
                if (item.key === "EnableItemWeightDisplay") {
                  return item.value === "1" ? (
                    <div className=" col-1" style={stylesASAP.title}>
                      Kg
                    </div>
                  ) : null;
                }
              })}
              <div className=" col-1" style={stylesASAP.title}>
                Free
              </div>
              {/* <div className=" col-1" style={stylesASAP.title}>
                Tax
              </div> */}
              <div className=" col-2" style={stylesASAP.title}>
                Total
              </div>
            </div>
          </div>
        ) : null}
        <div></div>
        <div>
          {this.state.SOL.filter((item) => item !== null && item !== undefined) // Remove null and undefined values
            .filter(
              (item) =>
                (item.qty && item.qty !== 0) || // Check if qty is valid
                (item.freeItem && item.freeItem !== 0) // Check if freeItem is valid
            )
            .sort((a, b) => a.name.localeCompare(b.name)) // Sort by name A to Z
            .map((item) => (
              <div className="row " key={item.id}>
                <div className=" col-4" style={stylesASAP.printfont}>
                  {item.name}
                </div>
                <div className=" col-1" style={stylesASAP.printfont}>
                  {item.qty !== undefined ? item.qty : 0}
                </div>
                <div className="col-2 text-center" style={stylesASAP.printfont}>
                  {item.unitPrice !== undefined ? item.unitPrice : 0}
                </div>
                {this.state.settingArray.map((item) => {
                  if (item.key === "EnableItemWeightDisplay") {
                    return item.value === "1" ? (
                      <div className=" col-1" style={stylesASAP.printfont}>
                        {item.weight !== undefined ? item.weight : 0}
                      </div>
                    ) : null;
                  }
                })}
                {/* <div className=" col-1">
                  {item.weight !== undefined ? item.weight : 0}
                </div> */}
                <div className=" col-1" style={stylesASAP.printfont}>
                  {item.freeItem !== undefined ? item.freeItem : 0}
                </div>
                {/* <div className=" col-1"  style={stylesASAP.printfont}>
                  {item.itemTax !== undefined
                    ? Number(item.itemTax).toFixed(1)
                    : 0}
                </div> */}
                {/* <div className=" col-1">
                  {item.disc !== undefined ? Number(item.disc) : 0}%
                </div> */}
                <div className=" col-2" style={stylesASAP.printfont}>
                  {item.totalPrice !== undefined
                    ? Number(item.totalPrice).toFixed(1)
                    : 0}
                </div>
                <hr />
              </div>
            ))}

          <div className="row">
            {/* <div className="col">
              <p className="pt-3 text-center h4 invisible">
                Untaxed Amount: {}
              </p>
            </div> */}
            <div className="col-3" style={stylesASAP.printfont}>
              <p className="pt-3 text-center h6 " style={stylesASAP.printtitle}>
                VAT: {this.numberWithCommas(this.state.VAT.toFixed(2))}
              </p>
            </div>
            <div className="col-3">
              <p className=" pt-3 text-center h6" style={stylesASAP.printtitle}>
                {this.state.TotalWeight !== 0
                  ? "Total-Weight" + " " + this.state.TotalWeight + " " + "kg"
                  : null}
              </p>
            </div>
            <div className="col-5">
              <p className="pt-3 text-center h6" style={stylesASAP.printtitle}>
                Total Amount:{" "}
                {this.numberWithCommas(
                  this.state.totalOrderPriceTaxed.toFixed(2)
                )}
              </p>
            </div>
          </div>
          <br />
          <div className="text-center">Payments</div>
          <div className="row m-1" style={stylesASAP.hr}>
            <div className=" col-5" style={stylesASAP.title}>
              Typee
            </div>
            <div className=" col-5" style={stylesASAP.title}>
              Amount
            </div>
          </div>

          <div>
            {this.state.amount !== undefined && this.state.amount !== null && this.state.amount.length !== 0 ? this.state.amount.map((item, index) => {
              return (
                <div className="row" key={index}>
                  <div className="col-5" style={stylesASAP.printfont}>
                    {item.type}
                  </div>
                  <div className="col-5" style={stylesASAP.printfont}>
                    {item.amount}
                  </div>
                  <hr />
                </div>
              );
            }): null}
          </div>

          <div className="row " style={stylesASAP.printfont}>
            <div className="row text-center " style={stylesASAP.printfont}>
              <p>
                <label style={stylesASAP.printfont}>SIGNATURE DATE : </label>
                {this.state.signatureDate === null ||
                this.state.sigantureTime === null
                  ? null
                  : this.state.signatureDate + " " + this.state.sigantureTime}
              </p>
            </div>
            <div className="col text-center">
              <img
                src={this.state.final}
                alt="Red dot"
                style={stylesASAP.printSignature}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
